<template>
  <div class="search-section">
      <v-container :class="{contain: $vuetify.breakpoint.mdAndUp}">
          <v-card dark color="primary">
              <v-container>
                      <v-row align="center" justify="center">
                          <v-col class="ma-0 pa-0" :md="6" :lg="6" :xl="6">
                              <p class="futara headline">Disc Recommendation App</p>
                          </v-col>
                          <v-col :cols="12" :md="6" :lg="6" :xl="6">
                                <v-card light>
                                    <v-autocomplete 
                                        :clearable="true"
                                        :disabled="disabled"
                                        dense
                                        rounded
                                        :items="discs"
                                        placeholder="Search by disc name"
                                        return-object
                                        v-model="selected"
                                        :search-input="searchText"
                                        item-text="model"
                                        prepend-icon="mdi-database-search"
                                        hide-no-data
                                        hide-selected
                                        class="front"
                                        @change="SendSearch()"
                                    >
                                        <template v-slot:item="{item}">
                                            <v-list-item-content>
                                                <v-list-item-title v-text="item.model"></v-list-item-title>
                                                <v-list-item-subtitle v-text="item.brand"></v-list-item-subtitle>
                                            </v-list-item-content>
                                        </template>
                                    </v-autocomplete>
                                </v-card>
                                <v-alert class="my-4" dense color="secondary" v-show="displayedObject.brand != undefined">
                                    Matches for <strong>{{selected.brand}} {{selected.model}}</strong>
                                </v-alert>
                          </v-col>
                      </v-row>
              </v-container>
          </v-card>
      </v-container>
  </div>
</template>

<script>
export default {
    name: "BuildBagView",
    components: {
    },
    props: {
        search: {
            type: Object,
            required: true,
            default: function(){return {}}
        },
        discs: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        selected: {},
        displayedObject:{},
        searchText: '',
    }),

    computed: {
    },

    methods: {
        SendSearch(){
            this.displayedObject = this.selected;
            this.$emit("update:search", this.selected);
        }
    },

    watch: {
        selected: function(){
            if(this.selected == undefined || this.selected == null){
                this.selected = {};
                this.displayedObject = {};
            }
        }
    }
}
</script>

<style scoped>
@import "../../../node_modules/futura-font/styles.css";
.search-section{
    background-color: black;
    border-bottom: red 4px solid;
}

.futara {
    font-family: 'Nunito', sans-serif;
}

.front {
    position: relative;
    z-index: 9999;
}

.testing{
    width: 100%;
}

.contain {
    width: 85%;
}
</style>